import { i18n } from '@/core/lib/i18n';
import { PoolMaxEntries } from '@/interface/enum';

export const MAX_SELECTED_COUNT = 4;

export const SERVICE_FEE_RATE = 0.05;

export const poolSizeConfigs = [
    { value: PoolMaxEntries.Unlimited, maxEntries: 0 },
    { value: PoolMaxEntries.Two, maxEntries: 2 },
    { value: PoolMaxEntries.Three, maxEntries: 3 },
    { value: PoolMaxEntries.Six, maxEntries: 6 },
];

export function getPoolSizeTitle(value: PoolMaxEntries) {
    const poolSizeTitleConfigs = [
        { value: PoolMaxEntries.Unlimited, title: i18n.t('fantasy_selection_unlimited_tab') },
        { value: PoolMaxEntries.Two, title: i18n.t('fantasy_selection_head_to_head_tab') },
        { value: PoolMaxEntries.Three, title: i18n.t('fantasy_selection_three_player_tab') },
        { value: PoolMaxEntries.Six, title: i18n.t('fantasy_selection_six_player_tab') },
    ];

    return poolSizeTitleConfigs.find(config => config.value === value)?.title ?? '';
}
